<template>
  <div class="modalnobefore">
    <search-group
      :multipleLines="true"
      :inline="false"
      :span="24"
      :btnOffset="18"
      :btnSpan="6"
      @search="findData"
      @clear="clearValue"
    >
      <Row :gutter="12" class="mb16">
        <Col span="5">
          <Select placeholder="请选择项目" v-model="searchData.projectFid" @on-change="changeProject">
            <Option value>请选择</Option>
            <Option
              v-for="(item,index) in projectList"
              :value="item.value"
              :key="'keyA'+index"
            >{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="请选择ZO" v-model="searchData.zoFid">
            <Option value>请选择</Option>
            <Option
              v-for="(item,index) in zoList"
              :value="item.value"
              :key="'keyB'+index"
            >{{item.text}}</Option>
          </Select>
        </Col>

        <Col span="5" class="flex">
          <span class="flexnone">综合评分:</span>
          <InputNumber
            class="flexauto"
            v-model="searchData.sumUpScoreFrom"
            :min="0"
            :precision="1"
            :step="0.1"
            :max="searchData.sumUpScoreTo"
            @on-change="changeFrom1"
          ></InputNumber>-
          <InputNumber
            class="flexauto"
            v-model="searchData.sumUpScoreTo"
            :min="searchData.sumUpScoreFrom"
            :max="5"
              :step="0.1"
              :precision="1"
            @on-change="changeTo1"
          ></InputNumber>
        </Col>
        <Col span="5" class="flex">
          <span class="flexnone">ZO服务得分:</span>
          <InputNumber
            class="flexauto"
            v-model="searchData.serviceScoreFrom"
            :min="0"
            :max="searchData.serviceScoreTo"
            @on-change="changeFrom1"
          ></InputNumber>-
          <InputNumber
            class="flexauto"
            v-model="searchData.serviceScoreTo"
            :min="searchData.serviceScoreFrom"
            :max="100"
            @on-change="changeTo1"
          ></InputNumber>
        </Col>
        <Col span="5" class="flex">
          <span class="flexnone">产品得分:</span>
          <InputNumber
            class="flexauto"
            v-model="searchData.productScoreFrom"
            :min="0"
            :max="searchData.productScoreTo"
            @on-change="changeFrom2"
          ></InputNumber>-
          <InputNumber
            class="flexauto"
            v-model="searchData.productScoreTo"
            :min="searchData.productScoreFrom"
            :max="100"
            @on-change="changeTo2"
          ></InputNumber>
        </Col>
      </Row>

      <Row class="mb16" :gutter="12">
        <Col span="4">
          <DatePicker
            class="block"
            type="daterange"
            placeholder="评价时间"
            v-model="searchData.evaluateTime"
          ></DatePicker>
        </Col>
        <Col span="4">
          <Select placeholder="产品星级" v-model="searchData.productStar" :multiple="true">
            <!--<Option value="">请选择</Option>-->
            <Option
              v-for="(item,index) in clist.productStar"
              :value="item.value"
              :key="'keyC1'+index"
            >{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="ZO服务星级" v-model="searchData.serviceStar" :multiple="true">
            <!--<Option value="">请选择</Option>-->
            <Option
              v-for="(item,index) in clist.serviceStar"
              :value="item.value"
              :key="'keyB'+index"
            >{{item.text}}</Option>
          </Select>
        </Col>

        <Col span="4" v-if="currentTab!=='ZADKPJ'" style="position: relative;">
          <Input v-model="searchData.contractCode" placeholder="请输入合同号" />
          <!--
          <span style="position: absolute;left: 10px;top: 35px;" class="error-color"  v-if="searchData.contractCode">企业合同请输入主合同号</span>
          -->
        </Col>
        <!--<Col span="4" v-if="searchData.contractCode && currentTab!=='ZADKPJ'">-->
        <!--<span style="line-height: 32px" class="error-color">企业合同请输入主合同号</span>-->
        <!--</Col>-->

        <Col span="4" v-if="currentTab==='ZADKPJ'">
          <Input v-model="searchData.customerPhone" placeholder="请输入手机号" />
        </Col>
        <Col span="4">
          <Select placeholder="请选择是否显示" v-model="searchData.isShow" >
              <Option value="">请选择</Option>
            <Option
              v-for="(item,index) in clist.showOrHide"
              :value="item.value"
              :key="'keyC'+index"
            >{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="请选择评价内容" v-model="searchData.isHaveSuggest" >
              <Option value="">请选择</Option>
            <Option
              v-for="(item,index) in clist.isHaveSuggest"
              :value="Number(item.value)"
              :key="'keyD'+index"
            >{{item.text}}</Option>
          </Select>
        </Col>
      </Row>
    </search-group>
    <Button
      class="mb16"
      type="primary"
      @click.stop="exportEvalution"
      :loading="buttonloading"
      v-p="{api:'evaluate/exportEvaluateList'}"
    >导出评价</Button>

    <table-list
      title
      :columns="columns"
      :data="data"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
    <img-show :n="imgN" :src="imgSrc"></img-show>
  </div>
</template>

<script>
import SearchGroup from "components/SearchGroup/index";
import TableList from "components/TableList/index";
import {
  getEvaluateList,
  exportEvaluateList,
  getExportEvaluateCount,
  toggleDisplay
} from "../../../../api/evaluation";
import { getProjectZos } from "../../../../api/common";
import ImgShow from "components/ImgListShow/index";
import { deepClone } from "../../../../utils/format";
import { formatDateTime } from "../../../../utils/format";

export default {
  name: "SearchList1",
  components: {
    SearchGroup,
    TableList,
    ImgShow
  },
  computed: {
    clist() {
      return {
        serviceStar: this.conditionList.serviceStar || [],
        productStar: this.conditionList.productStar || [],
        showOrHide: this.conditionList.showOrHide || [],
        isHaveSuggest: this.conditionList.isHaveSuggest || []
      };
    }
  },
  watch: {
    currentTab() {
      // this.clearValue()
      this.searchData.phoneNum = "";
      this.searchData.contractCode = "";
      this.findData();
    }
  },
  props: {
    conditionList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    projectList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    keyList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    currentTab: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      buttonloading: false,
      imgSrc: [],
      imgN: 0,
      searchKey: "",
      userInput: "",
      loading: false,
      searchData: {
        evaluateType: "ZADKPJ",
        page: 1,
        limit: 10,
        sumUpScoreFrom: 0,
        sumUpScoreTo: 5,
        serviceScoreFrom: 0,
        serviceScoreTo: 100,
        productScoreFrom: 0,
        productScoreTo: 100,
        projectFid: "",
        zoFid: "",
        productStar: [],
        evaluateTime: ["", ""],
        customerName: "",
        customerPhone: "",
        stockNumber: "",
        contractCode: "",
        evaluateTimeFrom: "",
        evaluateTimeTo: "",
        isShow: "",//显示隐藏状态 0隐藏   1显示
        isHaveSuggest: "",
        recommendStar: [],
        atmosphereStar: [],
        securityStar: [],
        serviceStar: [],
        maintainStar: [],
        cleaningStar: []
      },
      searched: null, // just for  changePage and export

      columns: [
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: " "
        },
        {
          title: "客户详情",
          width: 85,
          key: "",
          align: "center",
          render: (h, params) => {
            return h(
              "a",
              {
                on: {
                  click: () => {
                    this.getEvaluateModuleDetail(params.row);
                  }
                }
              },
              [h("Icon", { props: { type: "person" } }, "")]
            );
          }
        },
        {
          title: " "
        },
        {
          width: 85,
          title: "zo",
          key: "zoName",
          align: "center"
        },
        {
          title: " "
        },
        {
          width: 85,
          title: "综合评分",
          key: "sumUpScore",
          align: "center"
        },
        {
          title: " "
        },
        {
          width: 85,
          title: "zo服务星级",
          key: "serviceStar",
          align: "center"
        },
        {
          title: " "
        },
        {
          width: 85,
          title: "zo服务得分",
          key: "serviceScore",
          align: "center",
          render: (h, params) => {
            return h(
              "a",
              {
                on: {
                  click: () => {
                    this.showTagList(params.row, "zoTagList");
                  }
                }
              },
              params.row["serviceScore"]
            );
          }
        },
        {
          title: " "
        },
        {
          width: 85,
          title: "产品星级",
          key: "productStar",
          align: "center"
        },
        {
          width: 85,
          title: "产品得分",
          key: "productScore",
          align: "center",
          render: (h, params) => {
            return h(
              "a",
              {
                on: {
                  click: () => {
                    this.showTagList(params.row, "productTagList");
                  }
                }
              },
              params.row["productScore"]
            );
          }
        },
        {
          title: "评价内容",
          key: "evaluateContent",
          width: 140,
          align: "center",
          render: (h, params) => {
            if (
              params.row["evaluateContent"] &&
              params.row["evaluateContent"].length > 7
            ) {
              return h(
                "Tooltip",
                {
                  props: {
                    placement: "top"
                  }
                },
                [
                  h(
                    "div",
                    {
                      style: {
                        whiteSpace: "normal"
                      },
                      slot: "content"
                    },
                    params.row["evaluateContent"]
                  ),
                  h(
                    "span",
                    {},
                    params.row["evaluateContent"].slice(0, 7) + "..."
                  )
                ]
              );
            } else {
              return h("span", {}, params.row["evaluateContent"]);
            }
          }
        },
        {
          width: 85,
          title: "照片",
          key: "picUrl",
          align: "center",
          render: (h, params) => {
            return params.row["picUrl"] && params.row["picUrl"].length > 0
              ? h(
                  "a",
                  {
                    on: {
                      click: () => {
                        this.imgSrc = params.row["picUrl"];
                        this.imgN++;
                      }
                    }
                  },
                  "查看"
                )
              : h("span", {}, "无");
          }
        },

        {
          title: "评价时间",
          key: "evaluateTime",
          align: "center",
          width: 140
        },
        {
          title: "回访内容",
          key: "callBackContent",
          align: "center",
          width: 140,

          render: (h, params) => {
            if (
              params.row["callBackContent"] &&
              params.row["callBackContent"].length > 7
            ) {
              return h(
                "Tooltip",
                {
                  props: {
                    placement: "top"
                  }
                },
                [
                  h(
                    "div",
                    {
                      style: {
                        whiteSpace: "normal"
                      },
                      slot: "content"
                    },
                    params.row["callBackContent"]
                  ),
                  h(
                    "span",
                    {},
                    params.row["callBackContent"].slice(0, 7) + "..."
                  )
                ]
              );
            } else {
              return h("span", {}, params.row["callBackContent"]);
            }
          }
        },
        {
          title: " "
        },
        {
          title: "前端显示",
          key: "evaluateTime",
          align: "center",
          width: 140,
          render: (h, params) => {
            return h("span", params.row.isShow ? "显示" : "隐藏");
          }
        },
        {
          title: " "
        },
        {
          title: "是否显示",
          align: "center",
          width: 100,
          fixed: "right",
          render: (h, params) => {
           const popTitle = !params.row.isShow ? "显示" : "隐藏";
            return [
              h(
                "a",
                {
                  directives: [
                    {
                      name: "p",
                      value: {
                        api: "evaluate/showOrHide"
                      }
                    }
                  ],
                  on: {
                    click: () => {
                       
                      this.$Modal.confirm({
                        title: popTitle + "评价",
                        content: "<p>确认" + popTitle + "本条评价？</p>",
                        onOk: () => {
                          const queryData={
                            evaluateCode: params.row.collectCode,
                            // eslint-disable-next-line no-extra-boolean-cast
                            isShow:+!Boolean(params.row.isShow)
                          }
                          toggleDisplay(queryData).then (res=>{
                            if(res.code === 0){
                              this.$Message.success('状态切换成功')
                           setTimeout(()=>{
                                this.getEvaluateList(this.searchData);
                             },1000)
                            } else{
                              this.$Message.info(res.message)
                            }
                          })
                        }
                      });
                    }
                  }
                },
                popTitle
              )
            ];
          }
        },
        {
          title: " "
        }
      ],
      data: [],
      total: 0,
      current: 1,
      zoList: []
    };
  },
  methods: {
    getEvaluateModuleDetail(item) {
      this.$emit("getdetail", item.businessCode);
    },

    exportEvalution() {
      // this.$emit('exportlist', this.total, this.searched || this.searchData)

      if (this.total === 0) {
        this.$Message.info("数据列表为空！");
        return;
      }
      this.buttonloading = true;

      getExportEvaluateCount(this.searched)
        .then(() => {
          exportEvaluateList(this.searched)
            .then(res => {
              const fileName = res.headers.filename || "excel.xls";
              const blob = new Blob([res.data]);

              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              this.buttonloading = false;
              // this.btnLoading = false
            })
            .catch(() => {
              this.buttonloading = false;
            });
        })
        .catch(() => {
          this.buttonloading = false;
        });
    },
    showTagList(item, params) {
      if (!item[params] || (item[params] && item[params].length === 0)) {
        this.$Message.info("暂无该得分详情");
        return;
      }

      this.$Modal.info({
        render: h => {
          // let list = [h('h3', {style: {marginBottom: '15px'}}, params === 'zoTagList' ? '管家得分详情' : '产品得分详情')]

          const list = [
            h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center"
                }
              },
              [
                h(
                  "h3",
                  { style: { marginBottom: "15px", display: "inline-block" } },
                  params === "zoTagList" ? "管家得分详情" : "产品得分详情"
                ),
                h(
                  "Tooltip",
                  {
                    props: {
                      placement: "top"
                    },
                    style: {
                      display: "inline-block",
                      width: "20px",
                      marginBottom: "10px"
                    }
                  },
                  [
                    h(
                      "div",
                      {
                        style: {
                          whiteSpace: "normal"
                        },
                        slot: "content"
                      },
                      "默认分值100分，客户勾选正面标签不加分，负面标签减分"
                    ),
                    h("Icon", {
                      props: {
                        type: "ios-help",
                        size: 20
                      },
                      style: {
                        marginLeft: "5px"
                      }
                    })
                  ]
                )
              ]
            )
          ];

          item[params].forEach(ele => {
            list.push(
              h("div", { style: { lineHeight: 2 } }, [
                h(
                  "Checkbox",
                  {
                    props: {
                      value: ele.selected,
                      disabled: true
                    }
                  },
                  ele.tagName
                )
              ])
            );
          });
          return h("div", { style: { marginTop: "-20px" } }, list);
        }
      });
    },
    changeFrom2(value) {
      if (value > this.searchData.productScoreTo) {
        this.searchData.productScoreTo = this.searchData.productScoreFrom;
      }
    },
    changeTo2(value) {
      if (value < this.searchData.productScoreFrom) {
        this.searchData.productScoreTo = this.searchData.productScoreFrom;
      }
    },
    changeFrom1(value) {
      if (value > this.searchData.serviceScoreTo) {
        this.searchData.serviceScoreFrom = this.searchData.serviceScoreTo;
      }
    },
    changeTo1(value) {
      if (value < this.searchData.serviceScoreFrom) {
        this.searchData.serviceScoreTo = this.searchData.serviceScoreFrom;
      }
    },

    changeProject(value) {
      this.searchData.zoFid = "";
      if (!value) {
        this.zoList = [];
      } else {
        this.getProjectZos();
      }
    },
    getProjectZos() {
      getProjectZos(this.searchData.projectFid)
        .then(res => {
          this.zoList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEvaluateList(data) {
      this.total = 0;
      // this.data = [];
      data["evaluateType"] = this.currentTab;
      data["evaluateTimeFrom"] = formatDateTime(data.evaluateTime[0]);
      data["evaluateTimeTo"] = formatDateTime(data.evaluateTime[1]);

      getEvaluateList(data)
        .then(res => {
          if (!res.data) {
            return;
          }

          this.total = res.data.total;
          this.data = res.data.rows;
          this.searched = deepClone(data);
        })
        .catch(() => {
          return;
        });
    },
    findData() {
      this.current = 1;
      this.searchData.page = 1;
      // this.total=0
      // this.searchData.stockNumber=''
      // this.searchData.customerName=''
      // this.searchData.contractCode=''
      // this.searchData.customerPhone=''

      // if (this.userInput && this.searchKey) {
      //   this.searchData[this.searchKey] = this.userInput
      // }
      this.getEvaluateList(this.searchData);
    },
    clearValue() {
      this.searchKey = "";
      this.userInput = "";
      this.searchData = {
        page: 1,
        limit: 10,
        sumUpScoreFrom: 0,
        sumUpScoreTo: 5,
        serviceScoreFrom: 0,
        serviceScoreTo: 100,
        productScoreFrom: 0,
        productScoreTo: 100,
        projectFid: "",
        zoFid: "",
        evaluateTime: ["", ""],
        customerName: "",
        customerPhone: "",
        stockNumber: "",
        contractCode: "",
        productStar: [],
        isShow: "",
        isHaveSuggest: "",
        recommendStar: [],
        atmosphereStar: [],
        securityStar: [],
        serviceStar: [],
        maintainStar: [],
        cleaningStar: []
      };
    },
    changePage(n) {
      if (!this.searched) {
        this.searched = Object.assign({}, this.searchData);
      }
      this.searched.page = n;
      this.current = n;
      this.getEvaluateList(this.searched);
    }
  },
  created() {
    this.getEvaluateList(this.searchData);
  }
};
</script>

<style scoped>
.ivu-icon-information-circled:before {
  content: "" !important;
}

.flex {
  display: flex;
  align-items: center;
}

.flexauto {
  flex: auto;
}

.flexnone {
  flex: none;
  padding-right: 10px;
  width: 90px;
}

.search-wrapper {
  padding: 0;
}

.block {
  display: block;
}
</style>
